// export const baseUrl = 'http://10.12.0.32:9091/'
export const baseUrl = process.env.VUE_APP_BASE_URL
export const wxUrl = process.env.VUE_APP_WEAPP_URL
// export const baseUrl = 'https://zs.clousev.com/core/'

